import React, { useCallback, useEffect, useState } from "react";

import { getUserSettings, updateBio } from "services";

import { useCancelAsyncOnUnmount, useTranslation } from "utils";

import { ErrorBoundary, MainPage, Message as message } from "components";

import { Bio } from "pages/app/user/components/Bio";
import { ProfileBanner } from "pages/app/user/components/ProfileBanner";

export const Profile = () => {
  const signal = useCancelAsyncOnUnmount()();

  const { t } = useTranslation(["user", "onboarding", "meta", "dashboard"]);

  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState({});
  const [editBio, setEditBio] = useState(false);
  const [saving, setSaving] = useState(false);
  const [imageSuccess, setImageSuccess] = useState(false);
  const [imageURL, setImageURL] = useState(false);

  const loadUserSettings = useCallback(() => {
    setLoading(true);

    getUserSettings({
      signal,
    })
      .then((res) => {
        setImageURL(res.image && res.image !== "false" ? res.image : false);
        setImageSuccess(!!(res.image && res.image !== "false"));
        setDetails(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [signal]);

  const complete = (v) => {
    setSaving(true);

    updateBio({
      ...v,
      ...{ signal },
    })
      .then(() => {
        setSaving(false);
        setEditBio(false);

        loadUserSettings();

        message({
          content: t("profileUpdate.saved"),
          icon: "tick",
        });
      })
      .finally(() => {
        setSaving(false);
      });
  };

  useEffect(() => {
    loadUserSettings();
  }, [loadUserSettings]);

  return (
    <MainPage loading={loading} pageName={"profile"}>
      <ErrorBoundary>
        <ProfileBanner details={details} imageSuccess={imageSuccess} setImageSuccess={setImageSuccess} imageURL={imageURL} setImageURL={setImageURL} t={t} />
      </ErrorBoundary>
      <section className="container tiny">
        <ErrorBoundary>
          <Bio complete={complete} details={details} editBio={editBio} loading={loading} saving={saving} setEditBio={setEditBio} t={t} />
        </ErrorBoundary>
      </section>
    </MainPage>
  );
};
